export const jsonParser = (val)=>{
    try {
        if(val && typeof val === 'string'){
            return JSON.parse(val);
        }
        return val 
    } 
    catch (err){
        return val
    }
}